module.exports = __webpack_public_path__ + "img/Delete - Green - Selected.e77076ce.png";